import axios from 'axios'
import {BASE_URL} from '../ApiService/ApiConfig.js'

export class BookingService {

    async getBookingPorEstado(estado) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {
                estado: estado
            }
        }
        return await axios.get(`${BASE_URL}/booking/consultar/estado/`,
            config2
        ).then(res => res.data.data);
    }

    async getBookingPorEstadoParametro(estado) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {
                estado: estado
            }
        }
        return await axios.get(`${BASE_URL}/booking/consultar/estado-parametro/`,
            config2
        ).then(res => res.data.data);
    }

    async getBookingPorCodigo(codigo) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {
                codigo: codigo
            }
        }
        return await axios.get(`${BASE_URL}/booking/consultar/codigo/`,
            config2
        ).then(res => res.data.data);
    }



    async subirArchivo(archivo) {
        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }

        const formData = new FormData();
        formData.append('file', archivo);
        let axiosConfig = {
            headers: {
                'Content-Type': "multipart/form-data",
                'Authorization': 'Bearer ' + token
            },
        };

        return await axios.post(`${BASE_URL}/booking/upload-file`, formData, axiosConfig).then(res => res.data);
    }



    async getBookingPorFiltros(anio, mes, semana, diaSemana) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {

                anio: anio,
                mes: mes,
                semana: semana,
                diaSemana: diaSemana
            }
        }
        return await axios.get(`${BASE_URL}/viaje/consulta/booking/filtro-logistico`,
            config2
        ).then(res => res.data.data);
    }

    async getBookingPorFiltroLogistico(anio, mes, semana, diaSemana, estado) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {

                anio: anio,
                mes: mes,
                semana: semana,
                diaSemana: diaSemana,
                estado: estado
            }
        }
        return await axios.get(`${BASE_URL}/booking/filtro-logistico`,
            config2
        ).then(res => res.data.data);
    }


    async guardar(datos) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            }
        }
        return await axios.post(`${BASE_URL}/booking/lista`, { data: datos }, config).then(res => res.data.data);

    }


    async getBookingPorCodigo(codigo) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            }
        }
        return await axios.get(`${BASE_URL}/booking/consultar/booking/${codigo}`,
            config2
        ).then(res => res.data.data);
    }


    async getBookingPorEstadoParametro2(estado, codigo) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {
                estado: estado,
                codigo: codigo
            }
        }
        return await axios.get(`${BASE_URL}/booking/consultar/estado-parametro2/`,
            config2
        ).then(res => res.data.data);
    }
}
